export default {
      id: "weather__day-thunder-rainy-4-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__day-thunder-rainy-4",
      toString: function () {
        return this.url;
      }
    }